import type { PreviewsStatusProps } from '@components/shared/BudgetPreviewsStatus/types'

export const PROFILE_GU = 'Gerente de Unidade - GU'
export const PROFILE_TLR3 = 'Gerência Contas Estratégicas – TLR-3'
export const PROFILE_TLR2 = 'Gerência Operacional – TLR-2'
export const PROFILE_CONTROLLER = 'Controller Diretoria'
export const PROFILE_TLR1 = 'Diretoria Operacional – TLR-1'
export const PROFILE_HEAD_FIN = 'Head de Finanças BU'
export const PROFILE_VP_BU = 'Vice Presidência BU'

export const PROFILES_EDIT_STOCK_OPTION = [PROFILE_TLR1]

/** GCE, GO e Controller editam a prévia direto — não veem os botões Ajustar Prévia / Ver Ajustes. */
export const PROFILES_WITHOUT_ADJUST_BUTTONS = [PROFILE_TLR3, PROFILE_TLR2, PROFILE_CONTROLLER]

/** Usado só para os status iniciais do filtro do detalhamento (ver `getInitialConsolidatedPreviewFilters`). */
export const ADJUST_PREVIEW_REQUIRED_STATUSES: Partial<Record<string, PreviewsStatusProps[]>> = {
  [PROFILE_TLR2]: ['go_validation'],
  [PROFILE_CONTROLLER]: ['go_validation', 'go_validation_completed', 'completed_go_validation', 'controller_validation', 'returned_controller'],
  [PROFILE_TLR1]: ['director_validation'],
  [PROFILE_HEAD_FIN]: ['head_finance_validation', 'returned_head_finance'],
  [PROFILE_VP_BU]: ['vp_approval']
}

const NEXT_VALIDATION_HIERARCHY_BY_PROFILE: Record<string, string> = {
  [PROFILE_TLR3]: 'GO',
  [PROFILE_TLR2]: PROFILE_CONTROLLER,
  [PROFILE_CONTROLLER]: 'Diretoria Operacional',
  [PROFILE_TLR1]: PROFILE_HEAD_FIN,
  [PROFILE_HEAD_FIN]: PROFILE_VP_BU
}

export const getNextValidationHierarchy = (profileName?: string) => {
  return profileName ? NEXT_VALIDATION_HIERARCHY_BY_PROFILE[profileName] : undefined
}

const RETURN_HIERARCHY_BY_PROFILE: Record<string, string> = {
  [PROFILE_TLR3]: 'GU',
  [PROFILE_TLR2]: 'GU',
  [PROFILE_TLR1]: PROFILE_CONTROLLER,
  [PROFILE_VP_BU]: PROFILE_HEAD_FIN
}

export const getReturnHierarchy = (profileName?: string) => {
  return profileName ? RETURN_HIERARCHY_BY_PROFILE[profileName] : undefined
}

